import Update from "../../table/Update";
import { useState, useEffect } from "react";
import ApiService from "../../../services/apiService";
import { chackInstrumentTitle, updateChackInstrumentS } from "../../../constants";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
const UpdateChackInstrument = () => {
    const { Id } = useParams();
    const [chackData, setChackData] = useState<any>(null);
    const [chackInstrumentData, setChackInstrumentData] = useState<any>(null);
    const navigate = useNavigate();

    const initalData = {
        Instrument: chackInstrumentData?.instrument,
        Model: chackInstrumentData?.model,
        Make: chackInstrumentData?.make,
        InstallationReplacementDate: chackInstrumentData?.installationReplacementDate,
        Remark: chackInstrumentData?.remark,
        ChakName:chackInstrumentData?.chakName
    }
    useEffect(() => {

        const chack = async () => {
            try {
                const response = await ApiService.axiosApi(`/chack`, {
                    method: "GET",
                    params: {
                        pageNumber: 0,
                        pageSize: 0
                    }
                })
                if (response.success) {
                    setChackData(response.data.data)

                } else {
                    toast.error(response.message || "Failed to fetch chack data");
                }
            } catch (error: any) {
                toast.error(error.message || "Failed to fetch chack data");
            }
        }
        chack();
    }, [])

    useEffect(() => {
        const chackInstrumentData = async () => {
            try {
                const response = await ApiService.axiosApi(`/chackinstrumentdetail/${Id}`, {
                    method: "GET"
                });
                if (response.success) {
                    setChackInstrumentData(response.data)
                } else {
                    toast.error(response.message || "Failed to fetch chack instrument data");
                }
            } catch (error: any) {
                toast.error(error.message || "Failed to fetch chack instrument data");
            }
        }
        chackInstrumentData();
    }, [])



    const updateChackInstrument = async (data: any) => {
        try {
            const response = await ApiService.axiosApi(`/chackinstrumentdetail/${Id}`, {
                method: "PUT",
                data: data
            })
            if (response.success) {
                toast.success(response.message || "Chack instrument updated successfully");
                navigate(-1)
            } else {
                toast.error(response.message || "Failed to update chack instrument");
            }
        } catch (error: any) {
            toast.error(error.message || "Failed to update chack instrument");
        }
    }

    return (
        <Update title={updateChackInstrumentS}
            parentTitle={chackInstrumentTitle}
            fields={[
                {
                    name: "Instrument",
                    label: "Instrument",
                    type: "text"
                },
                {
                    name: "Model",
                    label: "Model",
                    type: "text"
                },
                {
                    name: "Make",
                    label: "Make",
                    type: "text"
                },
                {
                    name: "InstallationReplacementDate",
                    label: "Installation/Replacement Date",
                    type: "text",

                },
                {
                    name: "Remark",
                    label: "Remark",
                    type: "text",
                    vaildation: "Remark is required"
                },
                {
                    name: "ChakName",
                    label: "Chak",
                    isDropdown: true,
                    dropdownData: chackData,
                    dropdownLabel: "chackName",
                    idFieldName: "chakId"

                }


            ]}
            onSubmit={updateChackInstrument}
            initialData={initalData}

        />
    )
}
export default UpdateChackInstrument;
